import React, { useState, useEffect } from 'react';
import './ScrollDemo.css';

const ScrollDemo = () => {
    const [activeSection, setActiveSection] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            const sections = document.querySelectorAll('.scroll-section');
            const scrollPosition = window.scrollY + window.innerHeight / 2;

            sections.forEach((section, index) => {
                const sectionTop = section.offsetTop;
                const sectionBottom = sectionTop + section.offsetHeight;

                if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
                    setActiveSection(index);
                }
            });
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const longContent = Array.from({ length: 50 }, (_, i) => (
        <p key={i}>
            This is paragraph {i + 1} of a long content section that demonstrates
            independent scrolling within a 100vh section. Each paragraph adds to the
            content height, allowing you to test the nested scroll behavior.
        </p>
    ));

    return (
        <div className="scroll-container">
            {/* Section 1: Hero Section */}
            <section className={`scroll-section ${activeSection === 0 ? 'active' : ''}`}>
                <div className="scroll-section-content">
                    <div className="hero-content">
                        <h1>Full Viewport Scroll Demo</h1>
                        <p>Each section snaps to full viewport height</p>
                        <div className="scroll-indicator">
                            <span>↓ Scroll to explore</span>
                        </div>
                    </div>
                </div>
            </section>

            {/* Section 2: Normal Content */}
            <section className={`scroll-section ${activeSection === 1 ? 'active' : ''}`}>
                <div className="scroll-section-content">
                    <h2>Section 2: Standard Content</h2>
                    <p>This section fits within 100vh with normal content.</p>
                    <p>Scroll down to see the next section snap into view.</p>
                    <div className="content-grid">
                        <div className="grid-item">Feature 1</div>
                        <div className="grid-item">Feature 2</div>
                        <div className="grid-item">Feature 3</div>
                        <div className="grid-item">Feature 4</div>
                    </div>
                </div>
            </section>

            {/* Section 3: Overflow Content */}
            <section className={`scroll-section expanded ${activeSection === 2 ? 'active' : ''}`}>
                <div className="scroll-section-content">
                    <h2>Section 3: Overflow Content</h2>
                    <p>This section contains more content than 100vh and scrolls independently.</p>
                    <div className="long-content">
                        {longContent}
                    </div>
                    <p className="scroll-end">End of scrollable content</p>
                </div>
            </section>

            {/* Section 4: Mixed Content */}
            <section className={`scroll-section ${activeSection === 3 ? 'active' : ''}`}>
                <div className="scroll-section-content">
                    <h2>Section 4: Mixed Layout</h2>
                    <div className="mixed-layout">
                        <div className="demo-sidebar">
                            <h3>Sidebar</h3>
                            <ul>
                                <li>Navigation Item 1</li>
                                <li>Navigation Item 2</li>
                                <li>Navigation Item 3</li>
                            </ul>
                        </div>
                        <div className="main-content">
                            <h3>Main Content Area</h3>
                            <p>This demonstrates how mixed layouts work within the scroll system.</p>
                            <div className="card">
                                <h4>Card Title</h4>
                                <p>Card content that fits within the viewport.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Section 5: Final Section */}
            <section className={`scroll-section ${activeSection === 4 ? 'active' : ''}`}>
                <div className="scroll-section-content">
                    <div className="final-content">
                        <h2>Final Section</h2>
                        <p>You've reached the end of the scroll demo!</p>
                        <button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                            Back to Top
                        </button>
                    </div>
                </div>
            </section>

            {/* Navigation Dots */}
            <div className="nav-dots">
                {[0, 1, 2, 3, 4].map((index) => (
                    <button
                        key={index}
                        className={`nav-dot ${activeSection === index ? 'active' : ''}`}
                        onClick={() => {
                            const section = document.querySelectorAll('.scroll-section')[index];
                            section.scrollIntoView({ behavior: 'smooth' });
                        }}
                    />
                ))}
            </div>
        </div>
    );
};

export default ScrollDemo;
